<template>
    <div class="table-layout">
        <el-table :data="sorItems" border style="width: 100%" @cell-click="selectSortItemFunc" :show-header="false">
<!--            <el-table-column width="60">-->
<!--                <template slot-scope="rows">-->
<!--                    <div class="copy-radio ml15" :class="{'circle' : selectSortItem.code == rows.row.code}">-->
<!--                        <div class="circle-dot"></div>-->
<!--                    </div>-->
<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column align="left" label="排序条件" property="title"></el-table-column>
        </el-table>
    </div>
</template>

<script>
import { Utils } from '../../app.base'
//
export default {
    name: 'swb-org-tree-sort-set-list',
    desc: '组织机构树排序条件',
    data: function () {
        return {
            selectSortItem: {},
            sorItems: [{
                'title': '按创建时间',
                'code': 'createTime',
                'defVal': 'ASC'
            }, {
                'title': '按名称',
                'code': 'name',
                'defVal': 'ASC'
            }, {
                'title': '按机构编号',
                'code': 'no',
                'defVal': 'ASC'
            }, {
                'title': '按实际开业时间',
                'code': 'openedTime',
                'defVal': 'ASC'
            }, {
                'title': '按实际闭店时间',
                'code': 'closedTime',
                'defVal': 'ASC'
            }]
        }
    },
    created: function () {

    },
    methods: {
        selectSortItemFunc: function (selectData) {
            this.$emit('sortItem-change', selectData);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/orgStruct/orgTreeSortSet.vue